export class DealStatusModel {
    id: number;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/deal-status.model.ts